import { v4 as uuidv4 } from 'uuid'
import { DOMUtils } from '../../../../utils/dom'
import { IdentityEvent } from '../../../common/events/identity'
import { PermutiveEvent } from '../../../common/events/permutive'

declare let window: any

export class Permutive {
    /**
     * Initialize Permutive
     */
    public init(organizationId: string, workspaceId: string, workspaceApiKey: string): void {
        if (!window.permutive && organizationId && workspaceId && workspaceApiKey) {
            const permutive = window.permutive || {}
            permutive.q= []
            permutive.config= {}
            permutive.config.apiKey= workspaceApiKey
            permutive.config.workspaceId=workspaceId
            permutive.config.viewId = uuidv4()
            permutive.config.environment = 'production'

            const o = ['addon', 'identify', 'track', 'trigger', 'query', 'segment',
                 'segments', 'ready', 'on', 'once', 'user', 'consent']
            for (const r of o) {
                permutive[r] = (...args: any[]): void => {
                    const i = Array.prototype.slice.call(args, 0)
                    permutive.q.push({
                        arguments: i,
                        functionName: r
                    })
                }
            }
            window.permutive = permutive
            // send mp_id to Permutive
            addEventListener(IdentityEvent.MP_READY, (e: any) => {
                if (e.detail.mpId) {
                    window.permutive.identify([{
                        id: e.detail.mpId,
                        tag: 'mpId'
                    }])
                }
            })
            addEventListener(PermutiveEvent.FIRE_PAGE_VIEW, (evt: CustomEvent) => {
                if (window.permutive) {
                    // Add custom event to pageview event
                    window.permutive.addon('web', {
                        page:{...evt.detail}
                    })
                    // Load permutive script
                    DOMUtils.loadScript(`https://${organizationId}.edge.permutive.app/${workspaceId}-web.js`)
                    this.setGoogleTagTargeting()
                }
            })

        }
    }
    public setGoogleTagTargeting() {
        if (window.permutive) {
            // add permutive to googletag
            window.googletag=window.googletag||{}
            window.googletag.cmd=window.googletag.cmd||[]
            /* istanbul ignore next */
            window.googletag.cmd.push((): void => {
                if(0===window.googletag.pubads().getTargeting('permutive').length) {
                    const e=window.localStorage.getItem('_pdfps')
                    window.googletag.pubads().setTargeting('permutive',e?JSON.parse(e):[])
                    const permutiveId=window.localStorage.getItem('permutive-id')
                    if (permutiveId) {
                        window.googletag.pubads().setTargeting('puid',permutiveId)
                        window.googletag.pubads().setTargeting('ptime',Date.now().toString())
                    }
                    if (window.permutive.config.viewId) {
                        window.googletag.pubads().setTargeting('prmtvvid',window.permutive.config.viewId)
                    }
                    if (window.permutive.config.workspaceId) {
                        window.googletag.pubads().setTargeting('prmtvwid',window.permutive.config.workspaceId)
                    }
                }
            })
        }
    }

    // send events with attributes to Permutive
    public sendEvent(eventType: string,eventData: any) {
        if(window.permutive) {
            window.permutive.track(eventType, eventData)
        }
    }
}
